<template>
  <div class="date-range" :class="{ '-large': isLarge }" style="width: 250px">
    <div class="date-range__label" :class="{ '-large': isLarge }" :title="label" @click="menu()" :data-exclude="true"
      style="max-width: 250px; width: 250px;">
      <span :title="label" style="max-width: 250px; width: 250px">{{ label }}</span>
    </div>
    <div class="date-range__selectbox" :class="{ '-large': isLarge }" v-if="isOpen" v-click-outside="outside">
      <div class="date-range__options">
        <div class="date-range__option" :class="{ '-active': item.active }" v-for="(item, index) in ranges" :key="index"
          @click="selectRange(index)">
          {{ item.label }}
        </div>
      </div>
      <div class="date-range__datepicker">
        <div class="date-range__datepicker__labels">
          <div class="date-range__calendar">
            <div class="date-range__calendar__title">Başlangıç Tarihi</div>
            <div class="date-range__calendar__input">{{ start.label }}</div>
          </div>
          <div class="date-range__calendar">
            <div class="date-range__calendar__title">Bitiş Tarihi</div>
            <div class="date-range__calendar__input">{{ end.label }}</div>
          </div>
        </div>
        <div class="date-range__datepicker__input">
          <flat-pickr v-model="date" :config="config" @on-change="change"></flat-pickr>
        </div>
      </div>
      <div class="date-range__button">
        <form-button :text="'Güncelle'" @action="update()" :size="'full'" />
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import 'flatpickr/dist/flatpickr.css'
import { clickOutside } from '@/directives/'
import { makeDate } from '@/helpers'
export default {
  components: {
    flatPickr
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    move: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      label: 'Tarih aralığı seçin',
      date: null,
      start: {
        label: '-',
        value: null
      },
      end: {
        label: '-',
        value: null
      },
      isOpen: false,
      ranges: [
        {
          label: 'Son 30 Gün',
          day: 30,
          active: false
        },
        {
          label: 'Son 3 Ay',
          day: 90,
          active: false
        },
        {
          label: 'Son 6 Ay',
          day: 180,
          active: false
        },
        {
          label: 'Son 1 Yıl',
          day: 365,
          active: false
        },
      ],
      config: {
        altFormat: 'd F Y',
        dateFormat: 'Z',
        locale: Turkish,
        inline: true,
        mode: 'range'
      },
      allActive: false,
    }
  },
  watch: {
    value:function()
    {
      let vm = this
      vm.start.label = makeDate(this.value.start)
      vm.end.label =  makeDate(this.value.end)
      vm.label = `${vm.start.label} - ${vm.end.label}`
 
    }
  },

  directives: {
    'click-outside': clickOutside
  },
  created() {
  
    let vm = this
      vm.start.label = makeDate(this.value.start)
      vm.end.label =  makeDate(this.value.end)
      vm.label = `${vm.start.label} - ${vm.end.label}`
  },
  methods: {
    checkDefaultValue: function () {
      let vm = this
      if (vm.move) {
        let date1 = new Date("01/01/2017");
        let date2 = new Date();
        let temp = date2.getTime() - date1.getTime();
        let Difference_In_Days = temp / (1000 * 3600 * 24);
        vm.ranges.push({ active: false, day: Difference_In_Days, label: "Tümü" })
      }

      if (!vm.value) return

      vm.date = `${this.value.start} - ${this.value.end}`

      let dates = [this.value.start, this.value.end]

      vm.change(dates)

      vm.label = `Tarih aralığı seçin`
    },
    menu: function () {
      this.isOpen = !this.isOpen
    },
    selectRange: function (index) {
      let vm = this
      if (vm.ranges[index].active) {
        vm.date = null
        vm.ranges[index].active = false
        return
      }

      vm.ranges.forEach((item, indx) => {
        item.active = false
        if (indx == index) item.active = true
      })

      //  if(vm.label =="Tümü"){


      //   vm.date = ""
      //   vm.label = vm.ranges[index].label;
      //  }
      //  else{
      let _date = new Date(new Date().setDate(new Date().getDate() - vm.ranges[index].day))
    
      // let _date = new Date(new Date().setDate(new Date().getDate() - new Date(vm.ranges[index].day).getDate()))


      vm.date = `${_date} - ${new Date()}`
      vm.label = vm.ranges[index].label;
      //  }

    },
    change: function (e) {
      let vm = this

      // if(vm.label =="Tümü"){
      //        if (!e[1]) vm.ranges.forEach((item) => (item.active = false))

      // vm.start.value = null
      // vm.end.value = null


      // }
      // else{
      if (!e[1]) vm.ranges.forEach((item) => (item.active = false))

      vm.start.value = e[0] || null
      vm.end.value = e[1] || null


      // }
      vm.createLabel(e)

      return
    },
    update: function () {
      let vm = this

      let data = {
        start: vm.start.value,
        end: vm.end.value
      }




      vm.label = 'Tarih aralığı seçin'

      if (vm.start.value && vm.end.value) {
        let status = vm.ranges.some((item) => item.active)

        vm.label = status ? vm.ranges.find((item) => item.active).label : `${vm.start.label} - ${vm.end.label}`
      }
      // else{

      //    vm.label = "Tümü"
      // }

    
      vm.$emit('input', data)

      vm.isOpen = false
    },
    createLabel: function (dates) {
      let vm = this
      // if(vm.start.value ==null && vm.end.value==null){
      //         vm.start.label = '-'
      // vm.end.label = '-'
      // }else{
      vm.start.label = dates[0] ? makeDate(dates[0]) : '-'
      vm.end.label = dates[1] ? makeDate(dates[1]) : '-'
      // }

    },
    outside: function () {
      this.isOpen = false
    }
  }
}
</script>